// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] + "." + {"231":"fc84191f","824":"a4a36e93"}[chunkId] + ".chunk.js";
};